import { useRef, useState } from 'react'
import { connect } from 'react-redux'
import { dispatchSweetAlert } from '../../actions'
import { clearCart } from '../../redux/storeConfig/slices/slice.cart'

const ClearCartButton = props => {
  const clearing = useRef(false)
  const [clearState, setClearState] = useState('idle')
  const confirmClear = async () => {
    if (clearing.current) return
    clearing.current = true
    setClearState('pending')
    const cleared = await props.clearCart(props.currentLocation?.id)
    setClearState(cleared ? 'success' : 'error')
    clearing.current = false
  }

  const handleClick = () => {
    if (clearing.current) return
    // show sweetalert for confirmation,
    // passing in clear cart function callback

    const propsForSweetalert = {
      onConfirm: confirmClear,
      confirmBtnText: 'Yes, clear my cart',
      title: 'Remove all items from your cart?',
      alertMessage: 'You can not undo this action.',
      warning: true,
      alertType: 'warning',
      confirmBtnCssClass: 'mf-primary-btn alert-width-btn',
      cancelBtnCssClass: 'mf-outline-btn alert-width-btn'
    }

    props.dispatchSweetAlert(propsForSweetalert)
  }

  return (
    <div className="w-100 mf-m-0 mf-text-right">
      <sub
        className="red-text"
        style={{ textDecoration: 'underline', cursor: 'pointer' }}
        onClick={clearState === 'pending' ? undefined : handleClick}
        role="button"
        tabIndex={clearState === 'pending' ? -1 : 0}
        onKeyDown={event => {
          if (event.key === 'Enter' || event.key === ' ') handleClick()
        }}
        aria-disabled={clearState === 'pending' || !!props.errorMessage}
      >
        {clearState === 'pending' ? 'Clearing cart…' : 'Clear Cart'}
      </sub>
      {clearState === 'pending' && <p role="status">Clearing cart…</p>}
      {clearState === 'error' && <p role="alert">Your cart could not be cleared. Please try again.</p>}
    </div>
  )
}

const mapStateToProps = state => {
  return {
    currentLocation: state.storeViews.current
  }
}

export default connect(mapStateToProps, { clearCart, dispatchSweetAlert })(ClearCartButton)
